import { useMemo } from "react";
import { type IBudgetSettingsBankAccount } from "@services/budget/types";

export const useRemoveBankModalConflictingPlansList = (
  accounts: IBudgetSettingsBankAccount[],
) => {
  const conflicts = useMemo(() => {
    const conflictingExpensePlans = accounts.flatMap(
      (account) => account.associatedExpensePlans,
    );
    const conflictingSavingsPlans = accounts.flatMap(
      (account) => account.associatedSavingsPlans,
    );

    return {
      conflictingExpensePlans,
      conflictingSavingsPlans,
    };
  }, [accounts]);

  return conflicts;
};
